<template>
  <div class="analytic-tab-pane tab-pane">
    <PaymentInterestReports v-if="showComponent"/>
  </div>
</template>

<script>
  import PaymentInterestReports from './PaymentInterestReports'

  export default {
    name: 'PaymentInterestTab',
    components: {
        PaymentInterestReports
    },
    data() {
      return {
        showComponent: true
      }
    }
  }
</script>
